import { render, staticRenderFns } from "./CategoryNavigation.vue?vue&type=template&id=b1e6af84&scoped=true&"
import script from "./CategoryNavigation.vue?vue&type=script&lang=js&"
export * from "./CategoryNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e6af84",
  null
  
)

export default component.exports